import { Button } from "@mui/material";
import { COLOR_BLACK, COLOR_GREY_BORDER, COLOR_TEXT_MUTE, COLOR_WHITE_LIGHTER } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING, SPACING_DENSE, SPACING_HALF } from "helpers/spacings";
import React from "react";

// Compact outline button used for the leaderboard header actions (Stat key / CSV).
export function HeaderButton({ label, icon, onClick }) {
  return (
    <Button
      color="inherit"
      onClick={onClick}
      startIcon={icon}
      style={{
        flexShrink: 0,
        minHeight: 44,
        textTransform: "none",
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontWeight: 500,
        fontSize: 14,
        backgroundColor: COLOR_WHITE_LIGHTER,
        color: COLOR_BLACK,
        padding: `${SPACING_DENSE} ${SPACING_HALF}`,
        border: `1px solid ${COLOR_GREY_BORDER}`,
        borderRadius: 8,
      }}
    >
      {label}
    </Button>
  );
}

// Expandable glossary panel: a compact multi-column list of "TERM — description" lines plus an
// optional footnote. Shown below the header when the "Stat key" toggle is on.
export default function StatKeyPanel({ entries, footnote, minColumnWidth = 220 }) {
  return (
    <div
      style={{
        border: `1px solid ${COLOR_GREY_BORDER}`,
        borderRadius: 12,
        backgroundColor: COLOR_WHITE_LIGHTER,
        padding: SPACING,
        display: "flex",
        flexFlow: "column nowrap",
        gap: SPACING_HALF,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fill, minmax(${minColumnWidth}px, 1fr))`,
          columnGap: SPACING,
          rowGap: SPACING_DENSE,
        }}
      >
        {entries.map(({ term, description }) => (
          // 11px is the type-scale floor (§2), used here for dense, supplementary reference content.
          <div key={term} style={{ fontFamily: FONT_FAMILY_GRAPHIK, fontSize: 11, lineHeight: 1.4 }}>
            <span style={{ fontWeight: 600, letterSpacing: 0.5, color: COLOR_BLACK }}>{term}</span>
            <span style={{ color: COLOR_TEXT_MUTE }}> — {description}</span>
          </div>
        ))}
      </div>
      {footnote && (
        <div style={{ fontFamily: FONT_FAMILY_GRAPHIK, fontSize: 11, color: COLOR_TEXT_MUTE, lineHeight: 1.4 }}>
          {footnote}
        </div>
      )}
    </div>
  );
}
